import React, { useMemo, useRef } from "react";
import { BarChart } from 'echarts/charts';
import { EchartsCore } from "../Echart/UseEcharts";

import { PROGRESSBAR_CHART_COLORS } from "../../constants/echarts-colors.constants";

const ProgressBarChart = ({ items }) => {
  if (!items || items.length === 0) return null;

  const ReactEchart = useMemo(() => EchartsCore([BarChart]), []);

  const data = useMemo(() => {
    const totalPercent = items.reduce((sum, item) => sum + item.percent, 0);
    const adjustedData = items.map((item, index) => ({
      value: item.percent,
      name: item.label,
      color: PROGRESSBAR_CHART_COLORS[index]
    }));

    if (totalPercent < 100) {
      adjustedData.push({
        value: 100 - totalPercent,
        name: "Other",
        color: "#E1E1E2",
      });
    }

    return adjustedData;
  }, [items]);

  const getItemBorderRadius = (index) => {
    const bR = 6;
    if (index === 0 && index === data.length - 1) return [bR, bR, bR, bR];
    if (index === 0) return [bR, 0, 0, bR];
    return index === data.length - 1 ? [0, bR, bR, 0] : [0, 0, 0, 0];
  };

  const series = useMemo(() => (
    data.map((item, index) => ({
      name: item.name,
      type: 'bar',
      stack: 'total',
      data: [item.value],
      itemStyle: { borderRadius: getItemBorderRadius(index), color: item.color },
      label: { show: true, color: '#fff', formatter: (params) => `${params.value}%` },
    }))
  ), [data]);

  const options = useMemo(() => ({
    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' },  valueFormatter: (value) => `${value}%` },
    grid: { left: '0', right: '0', bottom: '0', top: '0' },
    xAxis: { type: 'value', splitLine: { show: false } },
    yAxis: { type: 'category', axisLine: { show: false }, data: [''] },
    series
  }), [series]);

  return (
    <div>
      <ReactEchart lazyUpdate opt={{ renderer: 'svg' }} option={options} style={{ width: '100%', height: '22px' }}/>
    </div>
  );
};

export default React.memo(ProgressBarChart);
